import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function PanikAtakTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['panik-atak-testi']} />;
}
